// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"48":"ba89fca8","496":"cb6ad866","551":"7f533829","767":"7669863e"}[chunkId] + ".css";
};